import QRCode from "@/components/QRCode/index.vue";
import TelegramUtil from "@/lobby_common/utils/telegramUtil.js";
import { cocosDownload } from "@/lobby_common/utils/appPostMessage.js";
import { isMobile, isPWA } from "@/lobby_common/utils/utils.js";
import { dynamicCreateManifest } from "@/lobby_common/utils/dynamicCreateManifest";
import { locationJump } from "@/lobby_common/utils/eventFunction.js";

export default {
  name: "mode18",
  components: { QRCode },
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isMobile: isMobile,
      isPWA: isPWA(),
      userType: "ios",
      cur_invite_code: "",
      iosdownloadUrl: "",
      andrioddownloadUrl: "",
      drawerVisible: false,
      showType: "",
      pwaIcon: "",
      deferredPropmpt: null,
      bannerPC: 300,
      bannerH5: 220,
      resizeTimer: null,
    };
  },
  computed: {
    listFormat() {
      return this.langInfoObj?.background || [];
    },
    getIsMobile() {
      return this.$store.getters.getIsMobile;
    },
    lang() {
      return this.$store.getters.getLang || "en";
    },
    langInfoObj() {
      const list = this.item?.list || [];
      const langInfo = list[0]?.langInfoObj || {};
      const langInfoObj = langInfo[this.lang] || {};
      console.log("langInfoObj", langInfoObj);
      return langInfoObj;
    },
    packageConfig() {
      return this.$store.getters.getPacketConfig?.site || {};
    },
    ios() {
      const params = encodeURIComponent(`light=1&terminaltype=lightweight`);
      const obj = {
        name: "down.ios",
        link:
          this.packageConfig.iosType === "PACK_TYPE_LIGHT"
            ? this.$store.getters.getPacketConfig?.site?.iosAddr +
              `/adsevent/v1/download?jumper=true&appSid=${this.appSid}&uid=''&params=${params}`
            : this.$store.getters.getPacketConfig?.site?.iosAddr,
        id: 1,
      };
      return obj;
    },
    andriod() {
      const obj = {
        name: "down.andriod",
        // link: this.$store.getters.getPacketConfig?.site?.androidAddr || "",
        link:
          this.packageConfig.androidType !== "PACK_TYPE_DESKTOP_QUICK"
            ? this.packageConfig.androidAddr
            : window.location.origin,
        id: 2,
      };

      return obj;
    },
    getAndroidLogo() {
      return this.pwaIcon;
    },
    getIOSimg() {
      return require(`@/lobby_common/assets/pwaImg/ios_${this.lang}.png`);
    },
    appSid() {
      return this.$store.getters.getPacketConfig?.appConfig?.sid;
    },
  },
  watch: {},
  created() {
    const old_ic = localStorage.getItem("inviteCode");
    const user_ic = JSON.parse(localStorage.getItem("USER_DATA"));
    if (user_ic && user_ic.inviteCode) {
      this.cur_invite_code = user_ic.inviteCode;
    } else {
      this.cur_invite_code = JSON.parse(old_ic);
    }
    const system = this.systemCheack() || "Android";
    if (system === "Android") {
      this.userType = "andriod";
    }
    if (system === "ios") {
      this.userType = "ios";
    }
  },
  mounted() {
    // console.log("mode18============mounted==============mode18", this.item);
    this.handlePcTab(1);
    this.handlePcTab(2);
    const packageConfig = this.$store.getters.getPacketConfig?.site || {};
    // console.log("packageConfig", packageConfig);

    dynamicCreateManifest(packageConfig, "pwa");
    this.pwaIcon = packageConfig.desktopSmallIcon;
    window.addEventListener(
      "beforeinstallprompt",
      this.beforeinstallprompthandler
    );
    
    // 监听窗口大小变化，重新计算轮播图高度
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 清理事件监听器和定时器
    window.removeEventListener('resize', this.handleResize);
    clearTimeout(this.resizeTimer);
  },
  methods: {
    handleImageLoad(event) {
      const img = event.target;
      if (img) {
        // 设置最小和最大高度限制
        const minHeight = this.getIsMobile ? 150 : 200;
        const maxHeight = this.getIsMobile ? 350 : 500;
        
        // 在移动端获取渲染高度，PC端获取自然高度
        const targetHeight = this.getIsMobile ? img.offsetHeight : img.naturalHeight;
        
        if (targetHeight) {
          const finalHeight = Math.max(minHeight, Math.min(maxHeight, targetHeight));
          
          if (this.getIsMobile) {
            this.bannerH5 = finalHeight;
          } else {
            this.bannerPC = finalHeight;
          }
        }
      }
    },
    // 检查系统是安卓还是ios
    systemCheack() {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // 安卓机！
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端.
      if (isAndroid) {
        return "Android";
      }
      if (isIOS) {
        return "ios";
      }
    },
    handlePcTab(active) {
      let url = "";
      if (this.isMobile()) {
        if (this.userType === "ios") {
          url = this.ios.link;
        } else {
          url = this.andriod.link;
        }
      } else {
        // pc
        if (active === 1) {
          url = this.ios.link;
        } else {
          url = this.andriod.link;
        }
      }
      if (active === 1) {
        this.iosdownloadUrl = this.codeFun(url);
      } else {
        this.andrioddownloadUrl = this.codeFun(url);
      }
    },
    downloadAppPC(active) {
      if (active === 1) {
        this.$eventPost("download_template", {
          SubMethod: "IOS",
        });
      } else {
        this.$eventPost("download_template", {
          SubMethod: "Android",
        });
      }
      const packageConfig = this.$store.getters.getPacketConfig?.site || {};
      let url = this.ios.link;
      if (active === 2) {
        url = this.andriod.link;
      }
      const cur_url = this.codeFun(url);
      if (isMobile()) {
        if (this.userType === "andriod" && !packageConfig.androidAddr) {
          this.handleClickToHome();
          return;
        }
        TelegramUtil.hideBackButton();
        // window.location.href = cur_url;
        locationJump(cur_url);
      } else {
        if (this.userType === "andriod" && !packageConfig.androidAddr) {
          this.handleClickToHome();
          return;
        }
        window.open(cur_url);
      }

      const eventName = ["", "download_ios", "download_android"][active];
      this.$eventPost(eventName);
    },
    downloadApp() {
      if (this.userType === "ios") {
        this.$eventPost("download_template", {
          SubMethod: "IOS",
        });
      } else if (this.userType === "andriod") {
        this.$eventPost("download_template", {
          SubMethod: "Android",
        });
      }
      const packageConfig = this.$store.getters.getPacketConfig?.site || {};
      let eventName = "";
      if (
        this.userType === "ios" &&
        packageConfig.iosType === "PACK_TYPE_DESKTOP_QUICK"
      ) {
        this.drawerVisible = true;
        return;
      }
      if (this.userType === "andriod" && !packageConfig.androidAddr) {
        this.handleClickToHome();
        return;
      }
      let url = this.andriod.link;
      let id = this.andriod.id;
      eventName = "download_android";
      if (this.userType === "ios") {
        url = this.ios.link;
        id = this.ios.id;
        eventName = "download_ios";
      }

      const cur_url = this.codeFun(url);
      cocosDownload(cur_url);
      // window.location.href = cur_url;
      locationJump(cur_url);
      window.ttq?.track("Download");
      this.$eventPost(eventName);
    },
    codeFun(url) {
      if (!url) return "";
      if (!this.cur_invite_code) {
        return url;
      } else {
        if (url.indexOf("?") !== -1) {
          return url + "&uid=" + this.cur_invite_code;
        } else {
          return url + "?uid=" + this.cur_invite_code;
        }
      }
    },
    beforeinstallprompthandler(event) {
      event.preventDefault();
      this.deferredPropmpt = event;
      window.deferredPropmpt = event;
    },
    handleClickToHomeClick() {
      this.$eventPost("download_template", {
        SubMethod: "Android",
      });
      this.handleClickToHome();
    },
    handleClickToHome() {
      if (window.deferredPropmpt) {
        window.deferredPropmpt.prompt();
        window.deferredPropmpt.userChoice.then((res) => {
          if (res.outcome === "accepted") {
            console.log(" user accepted add to home screen");
            Notification.requestPermission().then((res) => {
              if (res === "granted") {
                // navigator.serviceWorker.ready.then((registration) => {
                //   registration.showNotification("标题", {
                //     body: "应用已添加到主屏幕，祝您游玩愉快！",
                //   });
                // });
              }
            });
          } else {
            console.log(" user dismissed add to home screen");
          }
          this.drawerVisible = false;
        });
      } else {
        // 设备不支持
        this.$message({
          message: this.$t("Datalang.newly_device_unsupported"),
          type: "error",
          showClose: true,
        });
      }
    },
    handleCancel() {
      this.drawerVisible = false;
    },
    handleResize() {
      // 防抖处理，避免频繁触发
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.$nextTick(() => {
          // 尝试获取轮播图中的第一张图片
          const carouselImgs = document.querySelectorAll('#pc_carousel .carousel-img');
          const firstImg = carouselImgs[0];
          if (firstImg && firstImg.naturalHeight) {
            this.handleImageLoad({ target: firstImg });
          }
        });
      }, 300);
    },
  },
};
